module.exports = __webpack_public_path__ + "static/media/psychologi_test.cc3edad4.jpg";